export enum Urls {
  Home = '/',

  SignIn = '/sign-in',
  SignUp = '/sign-up',
  SignOut = '/sign-out',
  ForgotPassword = '/forgot-password',
  RecoveryPassword = '/recovery-password',

  Admin = '/admin',
  AdminUsers = '/admin/users',
}
